(() => {
  const drawer = document.querySelector('[data-lcp-drawer]');
  const openButton = document.querySelector('[data-lcp-open]');
  if (!drawer || !openButton) return;

  const styleId = 'lcp-mobile-menu-fix';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media (max-width: 989px) {
        .lcp-drawer {
          height: 100vh;
          height: 100dvh;
          overscroll-behavior: contain;
        }
        .lcp-drawer__overlay {
          height: 100vh;
          height: 100dvh;
        }
        .lcp-drawer__panel {
          height: 100vh;
          height: 100dvh;
          max-height: 100dvh;
          overflow-y: auto;
          overflow-x: hidden;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
          padding-bottom: max(24px, env(safe-area-inset-bottom));
        }
        .lcp-drawer__head {
          padding-top: env(safe-area-inset-top);
        }
      }

      @media (min-width: 990px) {
        .lcq,
        [data-lcp-open],
        [data-lcp-drawer] {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const desktopLanguage = document.querySelector('#LcpLanguageDesktop');
  const drawerPanel = drawer.querySelector('.lcp-drawer__panel');

  if (desktopLanguage && drawerPanel && !drawerPanel.querySelector('#LcpLanguageMobile')) {
    const mobileLanguage = desktopLanguage.cloneNode(true);
    const locale = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    const labels = { nl: 'Taal', de: 'Sprache', fr: 'Langue', en: 'Language' };
    const label = document.createElement('span');
    const select = mobileLanguage.querySelector('select');

    mobileLanguage.id = 'LcpLanguageMobile';
    mobileLanguage.classList.remove('lcp-desktop-only');
    mobileLanguage.classList.add('lcp-drawer__account');
    label.textContent = labels[locale] || 'Taal';
    mobileLanguage.prepend(label);

    if (select) select.setAttribute('aria-label', labels[locale] || 'Taal');

    const accountLink = drawerPanel.querySelector('.lcp-drawer__account');
    if (accountLink) drawerPanel.insertBefore(mobileLanguage, accountLink);
    else drawerPanel.appendChild(mobileLanguage);
  }

  let scrollY = 0;
  let lastFocus = null;
  let htmlOverflow = '';
  let bodyState = null;

  const lockPage = () => {
    scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    htmlOverflow = document.documentElement.style.overflow;
    bodyState = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };

    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  const unlockPage = () => {
    document.documentElement.style.overflow = htmlOverflow;
    if (bodyState) {
      document.body.style.position = bodyState.position;
      document.body.style.top = bodyState.top;
      document.body.style.left = bodyState.left;
      document.body.style.right = bodyState.right;
      document.body.style.width = bodyState.width;
      document.body.style.overflow = bodyState.overflow;
    }
    window.scrollTo(0, scrollY);
  };

  const close = ({ restoreFocus = true } = {}) => {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openButton.setAttribute('aria-expanded', 'false');
    unlockPage();

    if (restoreFocus && lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  };

  const open = () => {
    if (window.matchMedia('(min-width: 990px)').matches) return;
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    lockPage();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');

    const closeButton = drawer.querySelector('[data-lcp-close]');
    if (closeButton) closeButton.focus();
  };

  openButton.addEventListener('click', open);

  drawer.querySelectorAll('[data-lcp-close]').forEach((button) => {
    button.addEventListener('click', () => close());
  });

  drawer.querySelectorAll('.lcp-mobile-parent-link').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  drawer.querySelectorAll('.lcp-mobile-nav a[href]').forEach((link) => {
    link.addEventListener('click', () => {
      close({ restoreFocus: false });
    });
  });

  drawer.querySelectorAll('.lcp-mobile-nav details').forEach((detail) => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      drawer.querySelectorAll('.lcp-mobile-nav details[open]').forEach((other) => {
        if (other !== detail) other.removeAttribute('open');
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  const desktop = window.matchMedia('(min-width: 990px)');
  const handleDesktop = (event) => {
    if (event.matches && drawer.classList.contains('is-open')) {
      close({ restoreFocus: false });
    }
  };

  if (desktop.addEventListener) desktop.addEventListener('change', handleDesktop);
  else if (desktop.addListener) desktop.addListener(handleDesktop);
})();
